export default {
    setInfoSchool(state, payload) {
        if (!payload.infoSchool) {
            state.school = null;
            return;
        }
        state.school = {
            ...state.school,
            ...payload.infoSchool
        };
    },
    setSchools(state, payload) {
        state.schools = payload.schools || [];
    },
    setCurrentSchoolId(state, payload) {
        state.currentSchoolId = payload;
    },
    setAttendanceTeachers(state, payload) {
        state.attendanceTeachers = payload;
    }
}